import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import PredefinedDateRanges from '../../../core/common/datePicker'
import { allClass, allSection, gender, names, status } from '../../../core/common/selectoption/selectoption'
import CommonSelect from '../../../core/common/commonSelect'
import TooltipOption from '../../../core/common/tooltipOption'
import UserService from '../../network/services/UserService'
import StudentModals from '../../peoples/students/studentModals'
import { getUser } from '../../network/auth/Auth'
import { Modal } from "react-bootstrap";

const SchoolGrid = () => {
  const [show, setShow] = useState(false);
  const routes = all_routes
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove('show');
    }
  };




  const navigation = useNavigate()

  interface Option {
    id: any;
    name: any;
    phone: any;
    city: any;
    logo: any;
    branches: any;
    company_ids: any;

  }

  interface Option2 {
    id: any;
    name: any;
    email: any;
    phone: any;
    city: any;
    logo: any;
    branches: any;
    company_ids: any;

  }
  const [companies, setCompanies] = useState<Option[]>([]);
  const [company, setCompany] = useState<Option2>();

  const getCompanyDetailsBypartnerId = async (id: any) => {
    setIsLoading(true)
    await UserService.getCompanyDetailsBypartnerId(id, (response: any) => {
      if (response?.data && response?.success) {
        setIsLoading(false)

        setCompanies(response.data[0].company_ids[0].branches)
        console.log(response.data)
      }
    })
  }

  const navigeSchoolDetails = (academyYear: any) => {
    navigation(routes.studentDetail, { state: { academyYear: academyYear } })
  }

  const navigeSchoolList = () => {
    navigation(routes.schoolList)
  }

  const handleClose = () => {
    setShow(false);
  };

  const showShoolMoodal = (schools: any) => {
    setShow(true)
    setCompany(schools)
    console.log(schools)

  }

  useEffect(() => {
    console.log(getUser().company_ids[0].branches)
    getCompanyDetailsBypartnerId(getUser().id)
  }, [])

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content content-two">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Schools Grid</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Schools</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Schools Grid
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />


            </div>
          </div>
          {/* /Page Header */}
          {/* Filter */}
          <div className="bg-white p-3 border rounded-1 d-flex align-items-center justify-content-between flex-wrap mb-4 pb-0">
            <h4 className="mb-3">Schools</h4>
            <div className="d-flex align-items-center flex-wrap">
              <div className="input-icon-start mb-3 me-2 position-relative">
                <PredefinedDateRanges />
              </div>
              <div className="dropdown mb-3 me-2">
                <Link
                  to="#"
                  className="btn btn-outline-light bg-white dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                >
                  <i className="ti ti-filter me-2" />
                  Filter
                </Link>
                <div className="dropdown-menu drop-width" ref={dropdownMenuRef}>
                  <form>
                    <div className="d-flex align-items-center border-bottom p-3">
                      <h4>Filter</h4>
                    </div>
                    <div className="p-3 pb-0 border-bottom">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Class</label>
                            <CommonSelect
                              className="select"
                              options={allClass}
                              defaultValue={allClass[0]}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Section</label>
                            <CommonSelect
                              className="select"
                              options={allSection}
                              defaultValue={allSection[0]}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="mb-3">
                            <label className="form-label">Name</label>
                            <CommonSelect
                              className="select"
                              options={names}
                              defaultValue={names[0]}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Gender</label>
                            <CommonSelect
                              className="select"
                              options={gender}
                              defaultValue={gender[0]}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Status</label>
                            <CommonSelect
                              className="select"
                              options={status}
                              defaultValue={status[0]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-3 d-flex align-items-center justify-content-end">
                      <Link to="#" className="btn btn-light me-3">
                        Reset
                      </Link>
                      <Link to={routes.studentGrid} className="btn btn-primary" onClick={handleApplyClick}>
                        Apply
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
              <div className="d-flex align-items-center bg-white border rounded-2 p-1 mb-3 me-2">
                <a
                  onClick={() => navigeSchoolList()}
                  className="btn btn-icon btn-sm me-1 bg-light primary-hover"
                >
                  <i className="ti ti-list-tree" />
                </a>
                <Link
                  to={routes.studentGrid}
                  className="active btn btn-icon btn-sm primary-hover"
                >
                  <i className="ti ti-grid-dots" />
                </Link>
              </div>
              <div className="dropdown mb-3">
                <Link
                  to="#"
                  className="btn btn-outline-light bg-white dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  <i className="ti ti-sort-ascending-2 me-2" />
                  Sort by A-Z{" "}
                </Link>
                <ul className="dropdown-menu p-3">
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1 active"
                    >
                      Ascending
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                    >
                      Descending
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                    >
                      Recently Viewed
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="dropdown-item rounded-1"
                    >
                      Recently Added
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Filter */}
          <div className="row">
            {/* Student Grid */}
            {companies && companies?.map((item: any, index: any) => (
              <div className="col-xxl-3 col-xl-4 col-md-6 d-flex" key={index}>
                <div className="card flex-fill">
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="dropdown">
                        <Link
                          to="#"
                          className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="ti ti-dots-vertical fs-14" />
                        </Link>
                        <ul className="dropdown-menu dropdown-menu-right p-3">
                          <li>
                            <a
                              className="dropdown-item rounded-1"
                              href="#"
                              onClick={() => showShoolMoodal(item)}
                            >
                              <i className="ti ti-menu me-2" />
                              View schools
                            </a>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item rounded-1"
                              to={routes.editStudent}
                            >
                              <i className="ti ti-edit-circle me-2" />
                              Edit
                            </Link>
                          </li>

                          <li>
                            <Link
                              className="dropdown-item rounded-1"
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target="#delete-modal"
                            >
                              <i className="ti ti-trash-x me-2" />
                              Delete
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="bg-light-300 rounded-2 p-3 mb-3">
                      <div className="d-flex align-items-center">
                        <a
                          className="avatar avatar-lg flex-shrink-0"

                          onClick={() => navigeSchoolDetails(item)}
                        >
                          <img
                            src={`data:image/png;base64,${item.logo}`}
                            className="img-fluid "
                            alt="img"
                          />
                        </a>
                        <div className="ms-2">
                          <h5 className="mb-0">
                            <a
                              onClick={() => navigeSchoolDetails(item)}>{item.name}</a>
                          </h5>

                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gx-2">
                      <div>
                        <p className="mb-0"></p>
                        <p className="text-dark"></p>
                      </div>
                      <div>
                        <p className="mb-0"> </p>
                        <p className="text-dark"></p>
                      </div>

                    </div>
                  </div>

                </div>
              </div>))}
            <>

            </>
            {/* /Student Grid */}

            <div className="col-md-12 text-center">
              {
                isLoading ? (<Link to="#" className="btn btn-primary">
                  <span
                    className="spinner-border spinner-border-sm align-middle me-1"
                    role="status"
                    aria-hidden="true"
                  />
                  Load More ...
                </Link>) : (<Link to="#" className="btn btn-primary">
                  <i className="ti ti-loader-3 me-2" />
                  Load More
                </Link>)
              }
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <StudentModals />



      <Modal show={show} onHide={handleClose} centered size="lg">
        <div className="modal-header">
          <h4 className="modal-title">View Details</h4>
          <button
            type="button"
            className="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body mb-0">
          <div className="parent-wrap">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="d-flex align-items-center mb-3">
                  <span className="avatar avatar-xl me-2">
                    <img
                      src={`data:image/png;base64,${company?.logo}`}
                      alt="img"
                    />
                  </span>
                  <div className="parent-name">
                    <h5 className="mb-1">{company?.name}</h5>
                    <p>Added on 25 Mar 2024</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <ul className="d-flex align-items-center">
                  <li className="mb-3 me-5">
                    <p className="mb-1">Email</p>
                    <h6 className="fw-normal">{company?.email}</h6>
                  </li>
                  <li className="mb-3">
                    <p className="mb-1">Phone</p>
                    <h6 className="fw-normal">{company?.phone}</h6>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <h5 className="mb-3">School branches</h5>
          {company?.branches && company?.branches?.map((item: any, index: any) =>
          (<div className="border rounded p-4 pb-1 mb-3">
            <div className="d-flex align-items-center justify-content-between flex-wrap pb-1 mb-3 border-bottom">
              <span className="link-primary mb-2">RFID</span>

              <a

                className="btn btn-primary mb-3"
              >
                View Details
              </a>

            </div>
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <div className="d-flex align-items-center mb-3">
                <Link to={routes.studentDetail} className="avatar">
                  <img
                    src={`data:image/png;base64,${item?.logo}`}
                    className="img-fluid rounded-circle"
                    alt="img"
                  />
                </Link>
                <div className="ms-2">
                  <p className="mb-0">
                    <Link to={routes.studentDetail}>{item?.name} </Link>
                  </p>
                  <span>-- --</span>
                </div>
              </div>
              <div className="col-lg-6">
                <ul className="d-flex align-items-center">
                  <li className="mb-3 me-5">
                    <p className="mb-1">Email</p>
                    <h6 className="fw-normal">{company?.email}</h6>
                  </li>
                  <li className="mb-3">
                    <p className="mb-1">Phone</p>
                    <h6 className="fw-normal">{company?.phone}</h6>
                  </li>
                </ul>
              </div>

            </div>
          </div>))}


        </div>
      </Modal>
    </>

  )
}

export default SchoolGrid